(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("oxziongui", [], factory);
	else if(typeof exports === 'object')
		exports["oxziongui"] = factory();
	else
		root["oxziongui"] = factory();
})(self, () => {
return 